let selectedCityId = null;
let selectedCountryId = null;
let selectedVehicleBrandName = null;
let selectedVehicleModelName = null;
let cities = [];
let selectedServices = [];
let allPackages = [];
let translations = null;

// Function to populate cities
function populateCities() {
    getCities().then(function (response) {
        cities = response.data.filter(city => !city.isHiddenOnWebsite && city.name !== 'NO_DATA');

        const citySelect = document.getElementById('citySelect');
        citySelect.innerHTML = `<option id="selectCityPlaceholder" value="">${translations.priceCalculator.selectCityPlaceholder}</option>`;

        cities.forEach(function (city) {
            const option = document.createElement('option');
            option.value = city.id;
            option.textContent = city.name;
            citySelect.appendChild(option);
        });
    }).catch(function (error) {
        console.error('Failed to load cities:', error);
    });
}

// Function to populate brands
function populateBrands() {
    getBrands().then(function (response) {
        var brandSelect = document.getElementById('brandSelect');
        var brands = response.data;

        brandSelect.innerHTML = `<option id="selectBrandPlaceHolder" value="">${translations.priceCalculator.selectBrandPlaceholder}</option>`;
        brands.forEach(function (brand) {
            var option = document.createElement('option');
            option.value = brand.id;
            option.textContent = brand.name;
            brandSelect.appendChild(option);
        });

        document.getElementById('brandSelect').disabled = false;
    }).catch(function (error) {
        console.error('Failed to load brands:', error);
    });
}

// Function to populate models based on selected brand
function populateModels(brandId) {
    getModelsByBrandId(brandId).then(function (response) {
        var modelSelect = document.getElementById('modelSelect');
        var models = response.data;

        modelSelect.innerHTML = `<option id="selectModelPlaceholder" value="">${translations.priceCalculator.selectModelPlaceholder}</option>`;
        models.forEach(function (model) {
            var option = document.createElement('option');
            option.value = model.id;
            option.textContent = model.name;
            modelSelect.appendChild(option);
        });

        document.getElementById('modelSelect').disabled = false;
    }).catch(function (error) {
        console.error('Failed to load models:', error);
    });
}

// Function to populate services and store package prices
function populateServices(packageData) {
    let baseServices = [];
    let premiumServices = [];

    // Store all available package prices for later use
    allPackages = packageData.packagePrices;

    // Separate services into base and premium
    packageData.services.forEach(service => {
        if (service.name === 'External Washing' || service.name === 'Internal Washing') {
            baseServices.push(service); // Base services
        } else {
            premiumServices.push(service); // Premium services
        }
    });

    if (baseServices.length !== 0) {
        // Populate base services
        const baseServicesContainer = document.getElementById('baseServicesContainer');
        baseServicesContainer.innerHTML = '';  // Clear previous services
        baseServices.forEach(service => {
            const serviceAccordion = createBootstrapAccordion(service);
            baseServicesContainer.appendChild(serviceAccordion);
        });

        document.getElementById('baseServicesAccordion').style.display = 'block';
    } else {
        document.getElementById('baseServicesAccordion').style.display = 'none';
    }

    if (premiumServices.length !== 0) {
        // Populate premium services
        const premiumServicesContainer = document.getElementById('premiumServicesContainer');
        premiumServicesContainer.innerHTML = '';  // Clear previous services
        premiumServices.forEach(service => {
            const serviceAccordion = createBootstrapAccordion(service);
            premiumServicesContainer.appendChild(serviceAccordion);
        });

        document.getElementById('premiumServicesAccordion').style.display = 'block';
        document.getElementById('premiumServicesTitle').style.display = 'block';
    } else {
        document.getElementById('premiumServicesAccordion').style.display = 'none';
        document.getElementById('premiumServicesTitle').style.display = 'none';
    }

    // Show services section
    document.getElementById('serviceSelection').style.display = 'block';
}

// Function to handle service selection
function handleServiceSelection(serviceId) {
    const serviceCheckbox = document.getElementById(serviceId);

    if (serviceCheckbox.checked) {
        // Add service to selectedServices array if selected
        if (!selectedServices.includes(serviceId)) {
            selectedServices.push(serviceId);
        }
    } else {
        // Remove service from selectedServices array if unchecked
        selectedServices = selectedServices.filter(id => id !== serviceId);
    }

    // Update the result card and its visibility based on service selection
    updateResultCard();
}

// Function to create a service accordion item using Bootstrap Accordion
function createBootstrapAccordion(service, isPremium = false) {
    const container = document.createElement('div');
    container.classList.add('accordion-item');
    container.classList.add('wo-accordion-item');

    // Extract translation key from service.name
    const serviceKey = service.name.replace(/\s+/g, ''); // Remove spaces to match the translation keys
    const serviceTitleKey = `${serviceKey}Title`;
    const serviceDescriptionKey = `${serviceKey}Description`;

    // Fetch the translated name and description from the translations object
    const serviceTitle = translations.priceCalculator[serviceTitleKey] || service.name; // Fallback to English name if translation not found
    const serviceDescription = translations.priceCalculator[serviceDescriptionKey] || service.description || "No description available";

    // Create the accordion header and body with translated content
    const accordionHeader = `
        <div class="accordion-header wo-accordion-header" id="heading${service.id}">
            <input type="checkbox" id="${service.id}" name="${service.name}" value="${service.id}" class="wo-accordion-checkbox" onchange="handleServiceSelection('${service.id}')">
            <button class="accordion-button collapsed wo-accordion-button" type="button" data-bs-toggle="collapse" data-bs-target="#collapse${service.id}" aria-controls="collapse${service.id}">
                ${serviceTitle} <!-- Use translated title -->
            </button>
        </div>
    `;

    const accordionBody = `
        <div id="collapse${service.id}" class="accordion-collapse collapse">
            <div class="accordion-body wo-accordion-body">
                ${serviceDescription} <!-- Use translated description -->
            </div>
        </div>
    `;

    container.innerHTML = accordionHeader + accordionBody;
    return container;
}


// Function to update and display the result card using the packagePrices
function updateResultCard() {
    const resultCard = document.getElementById('resultCard');
    const noResults = document.getElementById('noResults');
    const vehicleDescription = document.getElementById('vehicleName');
    const vehicleType = document.getElementById('vehicleType');
    const vehiclePrice = document.getElementById('vehiclePrice');
    const vehicleImage = document.getElementById('vehicleImage');

    const vehicleDescriptionText = `${selectedVehicleBrandName} ${selectedVehicleModelName}`;

    if (selectedServices.length === 0) {
        resultCard.style.display = 'none';
        noResults.style.display = 'none';
        return;
    }

    // Check if there is a matching package with the selected services
    const matchingPackage = findMatchingPackage();

    if (matchingPackage) {
        let vehicleTypeText = `${matchingPackage.vehicleTypeName} ${matchingPackage.vehiclePropertyName}`

        if (selectedVehicleBrandName === 'Scooter') {
            vehicleTypeText = 'Scooter';
        }

        // Display the vehicle description and price
        vehicleDescription.textContent = vehicleDescriptionText;
        vehicleType.textContent = vehicleTypeText;

        const totalPrice = matchingPackage.packagePricePrice.price + matchingPackage.packagePricePrice.vat;
        vehiclePrice.textContent = `${totalPrice.toFixed(2)} €`;

        vehicleImage.className = '';
        vehicleImage.classList.add('wo-result-card-image');

        if (selectedVehicleBrandName === 'Scooter') {
            vehicleImage.classList.add('wo-result-card-scooter');
        } else if (matchingPackage.vehiclePropertyName === 'XS') {
            vehicleImage.classList.add('wo-result-card-xs');
        } else if (matchingPackage.vehiclePropertyName === 'Small') {
            vehicleImage.classList.add('wo-result-card-small');
        } else if (matchingPackage.vehiclePropertyName === 'Medium') {
            vehicleImage.classList.add('wo-result-card-medium');
        } else if (matchingPackage.vehiclePropertyName === 'Large') {
            vehicleImage.classList.add('wo-result-card-large');
        } else if (matchingPackage.vehiclePropertyName === 'Premium') {
            vehicleImage.classList.add('wo-result-card-premium');
        }

        resultCard.style.display = 'block';
        noResults.style.display = 'none';
    } else {
        resultCard.style.display = 'none';
        noResults.style.display = 'block';
    }
}

// Function to find a matching package based on the selected services
function findMatchingPackage() {
    return allPackages.find(pkg => {
        const serviceIds = pkg.services.map(service => service.id);
        return selectedServices.every(serviceId => serviceIds.includes(serviceId) && pkg.services.length === selectedServices.length);
    });
}

// Function to load packages and services and store the package prices
function loadPackagesAndServices(vehicleModelId, cityId, countryId) {
    getPackagesAndServices(vehicleModelId, countryId, cityId).then(function (response) {
        populateServices(response);
    }).catch(function (error) {
        console.error('Failed to load packages and services:', error);
    });

    document.getElementById('resultCard').style.display = 'none';
}

// Reset functions
function resetAll() {
    document.getElementById('vehicleTypeSelection').style.display = 'none';
    document.getElementById('brandModelSelection').style.display = 'none';
    document.getElementById('serviceSelection').style.display = 'none';
    document.getElementById('resultCard').style.display = 'none';
    document.getElementById('noResults').style.display = 'none';

    document.getElementById('brandSelect').selectedIndex = 0;
    document.getElementById('modelSelect').selectedIndex = 0;
    document.getElementById('citySelect').selectedIndex = 0;

    selectedServices = [];
    selectedCityId = null;
    selectedCountryId = null;
}

function resetAtVehicleTypeSelection() {
    document.getElementById('vehicleTypeSelection').style.display = 'block';
    document.getElementById('brandModelSelection').style.display = 'none';
    document.getElementById('serviceSelection').style.display = 'none';
    document.getElementById('resultCard').style.display = 'none';
    document.getElementById('noResults').style.display = 'none';

    document.getElementById('brandSelect').selectedIndex = 0;
    document.getElementById('modelSelect').selectedIndex = 0;

    selectedServices = [];
}

function resetAtBrandModelSelection() {
    document.getElementById('brandModelSelection').style.display = 'block';
    document.getElementById('serviceSelection').style.display = 'none';
    document.getElementById('resultCard').style.display = 'none';
    document.getElementById('noResults').style.display = 'none';

    document.getElementById('brandSelect').selectedIndex = 0;
    document.getElementById('modelSelect').selectedIndex = 0;

    selectedServices = [];

}

function hideBrandModelSelection() {
    document.getElementById('brandModelSelection').style.display = 'none';

    document.getElementById('brandSelect').selectedIndex = 0;
    document.getElementById('modelSelect').selectedIndex = 0;

    selectedServices = [];
}

function findCityCountry(cityId) {
    const city = cities.find(city => city.id === cityId);
    return city ? city.country.id : null;
}


const initializePrezzi = document.getElementById('wo-main-prezzi');

if (initializePrezzi) {
    // Event listeners
    const carButton = document.getElementById('carButton');
    const scooterButton = document.getElementById('scooterButton');

    document.getElementById('citySelect').addEventListener('change', function () {
        selectedCityId = this.value;
        selectedCountryId = findCityCountry(selectedCityId);

        if (selectedCityId) {
            resetAtVehicleTypeSelection();
        } else {
            resetAll();
        }
    });

    carButton.addEventListener('click', function () {
        resetAtBrandModelSelection();
        carButton.classList.add('vehicle-card-active');
        scooterButton.classList.remove('vehicle-card-active');
        document.getElementById('modelSelect').disabled = true;
        document.getElementById('selectModelPlaceholder').style.display = 'block';
        populateBrands();
    });

    scooterButton.addEventListener('click', function () {
        resetAtBrandModelSelection();
        hideBrandModelSelection();
        scooterButton.classList.add('vehicle-card-active');
        carButton.classList.remove('vehicle-card-active');
        selectedVehicleBrandName = 'Scooter';
        selectedVehicleModelName = '';
        loadPackagesAndServices('a71b70f1-207b-457e-b72e-35351e397c6c', selectedCityId, selectedCountryId);
    });

    document.getElementById('brandSelect').addEventListener('change', function () {
        if (this.value) {
            selectedVehicleBrandName = this.options[this.selectedIndex].text;
            populateModels(this.value);
        }
    });

    document.getElementById('modelSelect').addEventListener('change', function () {
        if (this.value) {
            selectedVehicleModelName = this.options[this.selectedIndex].text;
            loadPackagesAndServices(this.value, selectedCityId, selectedCountryId);
        }
    });

    // Translation file for the price calculator
    document.addEventListener('DOMContentLoaded', function () {
        const path = window.location.pathname;
        const languageMatch = path.match(/^\/(en|fr|it)\//);
        const languageCode = languageMatch ? languageMatch[1] : 'it'; // default to Italian

        const translationsAll = {
            en: translationsEn, fr: translationsFr, it: translationsIt
        };

        translations = translationsAll[languageCode] || translationsIt;

        if (languageCode === 'it') {
            document.getElementById('divTermsIt').style.display = 'block';
            document.getElementById('divTermsFr').style.display = 'none';
            document.getElementById('groupStateCode').style.display = 'block';
            document.getElementById('state').required = true;
            document.getElementById('acceptTermsPrezziIt').required = true;
            document.getElementById('acceptTermsPrezziFr').required = false;

        } else {
            document.getElementById('divTermsIt').style.display = 'none';
            document.getElementById('divTermsFr').style.display = 'block';
            document.getElementById('groupStateCode').style.display = 'none';
            document.getElementById('state').required = false;
            document.getElementById('acceptTermsPrezziIt').required = false;
            document.getElementById('acceptTermsPrezziFr').required = true;

        }

        function updateContent() {
            // Update text content based on language
            document.getElementById('title').textContent = translations.priceCalculator.title;
            document.getElementById('citySelectTitle').textContent = translations.priceCalculator.pageTitle;
            document.getElementById('vehicleTypeTitle').textContent = translations.priceCalculator.selectModelTitle;
            document.getElementById('resetSearch').textContent = translations.priceCalculator.resetSearch;
            document.getElementById('noResultsTitle').textContent = translations.priceCalculator.noServicesCombinationWarningTitle;
            document.getElementById('noResultsText').textContent = translations.priceCalculator.noServicesCombinationWarningBody;

            document.getElementById('selectCityPlaceholder').textContent = translations.priceCalculator.selectCityPlaceholder;
            document.getElementById('selectBrandPlaceholder').textContent = translations.priceCalculator.selectBrandPlaceholder;
            document.getElementById('selectModelPlaceholder').textContent = translations.priceCalculator.selectModelPlaceholder;

            document.getElementById('baseServicesTitle').textContent = translations.priceCalculator.baseServicesTitle;
            document.getElementById('premiumServicesTitle').textContent = translations.priceCalculator.premiumServicesTitle;

            document.getElementById('first_nameLabel').textContent = translations.priceCalculator.salesForceName;
            document.getElementById('last_nameLabel').textContent = translations.priceCalculator.salesForceSurname;
            document.getElementById('emailLabel').textContent = translations.priceCalculator.salesForceEmail;
            document.getElementById('mobileLabel').textContent = translations.priceCalculator.salesForcePhone;
            document.getElementById('companyLabel').textContent = translations.priceCalculator.salesForceCompany;
            document.getElementById('state_codeLabel').textContent = translations.priceCalculator.salesForceProvince;
            document.getElementById('descriptionLabel').textContent = translations.priceCalculator.salesForceMessage;

            document.getElementById('submitButtonPrezzi').value = translations.priceCalculator.salesForceSubmit;
        }

        updateContent();
        populateCities();
    });
}